import { SaleModel } from 'api-hooks/sale/common';
import { SaleMinimalModel } from 'api-hooks/sale/model';
import { useGetSales } from 'api-hooks/sale/query';
import { OnChangeParams, Option } from 'baseui/select';
import { transformLabel } from 'common/utils/string';
import { Input } from 'components/elements';
import useSelectInputWithoutDetailHelper from 'hooks/use-select-input-without-detail-helper';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

function transformer(item: SaleModel | SaleMinimalModel): Option {
  return {
    id: item.id,
    label: transformLabel([item.number, item.code, item.customer.name]),
    extra: item,
  };
}

interface Props {
  name: string;
  required?: boolean;
  label?: string;
  placeholder?: string;
  onClose?: () => void;
  onAfterSelectItem?: (prevValue?: any, value?: any) => void;
  onAfterChange?: (value?: OnChangeParams) => void;
  // onAfterDetailChange?: (value: SalesModel) => void;

  noMargin?: boolean;
  disabled?: boolean;
  fieldType?: 'control' | 'uncontrol';
  hasProject?: boolean;
}

export default function SaleSelectInput(props: Props) {
  const { t } = useTranslation();
  const {
    label = t('common:invoice'),
    placeholder = t('common:select_invoice'),
    hasProject,
  } = props;

  const { control, setValue } = useFormContext<any>();
  const value = useWatch({ control, name: props.name });
  const { overrides, ...selectProps } = useSelectInputWithoutDetailHelper({
    value,
    onSelectItem: (_value) => {
      setValue(props.name, _value[0], {
        shouldTouch: true,
        shouldValidate: true,
      });
      props.onAfterSelectItem?.(value, _value[0]);
    },
    useListQueryHook: useGetSales,
    getMemoizedListVariables: React.useCallback(
      (page, q) => ({
        params: {
          q,
          page,
          filter: { status: 'active|completed' } as unknown as string,
          hasProject,
        },
      }),
      [hasProject],
    ),

    listTransformer(result) {
      const options = result.data.map((v) => transformer(v));
      return options;
    },

    paginationTransformer(result) {
      return result.meta;
    },
  });

  return (
    <Input
      type="select"
      name={props.name}
      required={props.required}
      label={label}
      placeholder={placeholder}
      onAfterChange={props.onAfterChange}
      noMargin={props.noMargin}
      disabled={props.disabled}
      fieldType={props.fieldType}
      {...selectProps}
    />
  );
}
